export default __webpack_public_path__ + "static/media/PaperLess.b5fc605e.svg";